export const SIGNUP_PASSWORD_MIN_LENGTH = 12;

export function getSignupPasswordError(password: string, confirmPassword: string): string | null {
  if (password.length < SIGNUP_PASSWORD_MIN_LENGTH) {
    return `Use at least ${SIGNUP_PASSWORD_MIN_LENGTH} characters.`;
  }

  if (password !== confirmPassword) {
    return "Passwords don't match.";
  }

  return null;
}
